import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import report from './modules/report'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    report,
    user
  },
  state: {
    controls: {
      showDrawer: null
    }
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    }
  }
})
